import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import IssuerPaymentScheduleCriteria from "./IssuerPaymentScheduleCriteria";
import { Neo } from "@singularsystems/neo-react";
import { ReportCategory } from "../ReportCategory";
import IssuerInvestmentAutoComplete from "../../../Domain/Components/IssuerInvestmentAutoComplete";

@NeoReport("IssuerPaymentSchedule", { category: ReportCategory.IssuerReports })
export default class IssuerPaymentScheduleReport extends Report<IssuerPaymentScheduleCriteria> {

    constructor() {
        super(IssuerPaymentScheduleCriteria);
    }

    public renderCriteria() {
      return <Neo.GridLayout>
          <div>
            <DateSelectionComponent criteria={this.criteria} />
      
            <Neo.FormGroup>
              <IssuerInvestmentAutoComplete
                bind={this.criteria.meta.issuerInvestmentId}
                bindDisplay={this.criteria.meta.issuerInvestmentName}
                useParentCache={false} />
            </Neo.FormGroup>
          </div>
      </Neo.GridLayout>
    }
}